import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Modal } from './ui/Modal';
export function FooterSection() {
  const [modalOpen, setModalOpen] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#05080f] py-12 border-t border-slate-800" data-id="element-1">
        <div className="container mx-auto px-4" data-id="element-2">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-3">
            <div className="flex items-center gap-2" data-id="element-4">
              <div className="w-8 h-8 rounded bg-[#25D366] flex items-center justify-center text-black font-bold" data-id="element-5">
                <MessageCircle className="h-5 w-5" data-id="element-6" />
              </div>
              <span className="text-white font-bold text-lg" data-id="element-7">
                Chatbot Agenda Total
              </span>
            </div>

            <div className="text-slate-500 text-sm" data-id="element-8">
              &copy; {new Date().getFullYear()} El Arquitecto de Agendas. Todos
              los derechos reservados.
            </div>

            <div className="flex gap-6 text-sm text-slate-400" data-id="element-9">
              <button onClick={() => setModalOpen('terms')} className="hover:text-white transition-colors" data-id="element-10">
                Términos y Condiciones
              </button>
              <button onClick={() => setModalOpen('privacy')} className="hover:text-white transition-colors" data-id="element-11">
                Política de Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      <Modal isOpen={modalOpen === 'terms'} onClose={() => setModalOpen(null)} title="Términos y Condiciones" data-id="element-12">
        <div className="space-y-4 text-sm" data-id="element-13">
          <p data-id="element-14">
            <strong data-id="element-15">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-16">
            1. Aceptación de los Términos
          </h4>
          <p data-id="element-17">
            Al acceder y utilizar este sitio web y adquirir nuestros productos
            digitales, usted acepta estar sujeto a estos términos y condiciones.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-18">
            2. Propiedad Intelectual
          </h4>
          <p data-id="element-19">
            Todo el contenido, incluyendo pero no limitado a textos, gráficos,
            logotipos, imágenes y software, es propiedad de "El Arquitecto de
            Agendas" y está protegido por las leyes de propiedad intelectual.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-20">3. Uso del Producto</h4>
          <p data-id="element-21">
            Al comprar nuestra guía, se le otorga una licencia personal, no
            exclusiva e intransferible para usar el material con fines
            educativos y comerciales propios. Queda estrictamente prohibida la
            reventa, distribución o copia pública del contenido.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-22">
            4. Política de Reembolso
          </h4>
          <p data-id="element-23">
            Ofrecemos una garantía de satisfacción. Si no está satisfecho con el
            producto, contáctenos dentro de los primeros 30 días para evaluar su
            caso.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-24">
            5. Limitación de Responsabilidad
          </h4>
          <p data-id="element-25">
            No nos hacemos responsables de ningún daño directo, indirecto,
            incidental o consecuente que resulte del uso o la imposibilidad de
            uso de nuestros materiales.
          </p>
        </div>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={modalOpen === 'privacy'} onClose={() => setModalOpen(null)} title="Política de Privacidad" data-id="element-26">
        <div className="space-y-4 text-sm" data-id="element-27">
          <p data-id="element-28">
            <strong data-id="element-29">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-30">
            1. Recopilación de Información
          </h4>
          <p data-id="element-31">
            Recopilamos información que usted nos proporciona directamente al
            realizar una compra, como su nombre, dirección de correo electrónico
            y detalles de pago.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-32">
            2. Uso de la Información
          </h4>
          <p data-id="element-33">
            Utilizamos la información recopilada para procesar sus
            transacciones, enviarle el producto digital y proporcionarle soporte
            al cliente. También podemos usar su correo electrónico para enviarle
            actualizaciones sobre el producto.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-34">3. Protección de Datos</h4>
          <p data-id="element-35">
            Implementamos medidas de seguridad para mantener la seguridad de su
            información personal. No vendemos, intercambiamos ni transferimos a
            terceros su información personal identificable.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-36">4. Cookies</h4>
          <p data-id="element-37">
            Utilizamos cookies para mejorar su experiencia en nuestro sitio web
            y analizar el tráfico. Puede optar por desactivar las cookies a
            través de la configuración de su navegador.
          </p>

          <h4 className="text-white font-bold mt-4" data-id="element-38">
            5. Cambios en la Política
          </h4>
          <p data-id="element-39">
            Nos reservamos el derecho de modificar esta política de privacidad
            en cualquier momento. Los cambios entrarán en vigor inmediatamente
            después de su publicación en el sitio web.
          </p>
        </div>
      </Modal>
    </>;
}